import {
	ZodArray,
	ZodBoolean,
	ZodEnum,
	ZodNativeEnum,
	ZodNumber,
	type ZodObject,
	ZodOptional,
	type ZodRawShape,
	ZodString,
} from 'zod';
import { getNestedSchema } from './getNestedSchema';

const DEBUG = false;

// ZodParsedType
// "nan",
// "integer",
// "float",
// "date",
// "bigint",
// "symbol",
// "function",
// "undefined",
// "null",
// "object",
// "promise",
// "void",
// "never",
// "map",
// "set",
export const FIELD_TYPE = {
	ARRAY: 'array',
	BOOLEAN: 'boolean',
	ENUM: 'enum',
	NATIVE_ENUM: 'native-enum',
	NUMBER: 'number',
	OTHER: 'other',
	STRING: 'string',
	UNKNOWN: 'unknown', // TODO when all types covered this should not be needed?
} as const;

export type FieldType = typeof FIELD_TYPE[keyof typeof FIELD_TYPE];

export interface GetFieldTypeParams {
	fieldName: string;
	zodSchema: ZodObject<ZodRawShape>;
}

export function getFieldType({
	fieldName,
	zodSchema,
}: GetFieldTypeParams): FieldType {
	if (DEBUG) console.debug('getFieldType(fieldName)', fieldName);
	if (DEBUG) console.debug('getFieldType(zodSchema)', zodSchema);

	const nestedSchema = getNestedSchema(zodSchema, fieldName);
	if (DEBUG) console.debug('getFieldType nestedSchema', nestedSchema);
	if (!nestedSchema) return FIELD_TYPE.UNKNOWN;

	if (nestedSchema instanceof ZodString) return FIELD_TYPE.STRING;
	if (nestedSchema instanceof ZodNumber) return FIELD_TYPE.NUMBER;
	if (nestedSchema instanceof ZodEnum) return FIELD_TYPE.ENUM;
	if (nestedSchema instanceof ZodNativeEnum) return FIELD_TYPE.NATIVE_ENUM;
	if (nestedSchema instanceof ZodBoolean) return FIELD_TYPE.BOOLEAN;
	if (nestedSchema instanceof ZodArray) return FIELD_TYPE.ARRAY;

	if (nestedSchema instanceof ZodOptional) return getFieldType({ // Recurse
		fieldName,
		zodSchema: nestedSchema._def.innerType as ZodObject<ZodRawShape>,
	});

	return FIELD_TYPE.OTHER; // TODO when all types covered this should not be needed?
}
